import axios from '@/lib/AxApi';

export default
{
    async selectRow(params)
    {
        try
        {
            const response = await axios.get('/UserSubCompanies/selectRow',
                {
                    params,
                });

            return response.data;
        }
        catch (e)
        {
            throw ({ error: true, notice: 'AXIOS_ERROR', params: { error: e } });
        }
    },
    async getCompaniesFromSubCompany(params)
    {
        try
        {
            const response = await axios.get('/UserSubCompanies/getCompaniesFromSubCompany', 
                {
                    params,
                });

            return response.data;
        }
        catch (e)
        {
            throw ({ error: true, notice: 'AXIOS_ERROR', params: { error: e } });
        }
    },
    async save(params)
    {
        try
        {
            let response;
            if (typeof params.id !== 'undefined' && params.id != '')
            {
                response = await axios.post('/UserSubCompanies/updateRow', params);
            }
            else
            {
                response = await axios.post('/UserSubCompanies/insertRow', params);
            }
            return response.data;
        }
        catch (e)
        {
            throw ({ error: true, notice: 'AXIOS_ERROR', params: { error: e } });
        }
    },
    async deleteRow(params)
    {
        try
        {
            const response = await axios.post('/UserSubCompanies/deleteRow', params);
            return response.data;
        }
        catch (e)
        {
            throw ({ error: true, notice: 'AXIOS_ERROR', params: { error: e } });
        }
    },
};
